import { Directive, HostListener, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { CpfValidator } from './../validators/cpf.validator';

@Directive({
  selector: '[cpfMask]', // Prefira usar um prefixo específico do projeto
  standalone: false,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CpfDirective,
      multi: true,
    },
  ],
})
export class CpfDirective implements Validator {
  @Input('appCpfMask') cpfMask: string = '999.999.999-99';

  constructor() { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return control.value ? CpfValidator.validate(control) : null;
  }

  @HostListener('input', ['$event'])
  onInput(event: InputEvent & { target: HTMLInputElement }) {
    if (event.inputType.includes("deleteContent")) {
      return;
    }
    let value = event.target.value.replace(/\D/g, '');
    if (value.length <= 11) {
      event.target.value = this.applyCpfMask(value);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent & { target: HTMLInputElement }) {
    const pastedText = event.clipboardData?.getData('text/plain');
    if (pastedText) {
      let value = pastedText.replace(/\D/g, '');
      if (value.length <= 11) {
        event.target.value = this.applyCpfMask(value);
      }
    }
  }

  private applyCpfMask(value: string): string {
    const cleanMask = this.cpfMask.replace(/\D/g, '').replace(/9/g, '_');
    const valueMask = value + cleanMask.substring(0, cleanMask.length - value.length);
    let valueMaskPos = 0;
    let formattedValue = '';

    for (let i = 0; i < this.cpfMask.length; i++) {
      formattedValue += isNaN(parseInt(this.cpfMask[i], 10)) ? this.cpfMask[i] : valueMask[valueMaskPos++];
    }

    return formattedValue.indexOf('_') > -1 ? formattedValue.substr(0, formattedValue.indexOf('_')) : formattedValue;
  }
}
